var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.33,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 170.67
  })), /*#__PURE__*/React.createElement("rect", {
    y: 170.67,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M255.678,313.332c-32.503,0-58.947-26.444-58.947-58.947c0-13.885,4.921-27.368,13.859-37.97   l2.576,2.171c-8.426,9.993-13.066,22.707-13.066,35.799c0,30.645,24.933,55.579,55.579,55.579L255.678,313.332L255.678,313.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M234.115,295.927c-0.736,1.256-1.099,2.98-1.26,4.732c-0.666-0.479-1.37-0.924-2.138-1.298   c0,0-1.158,4.081-0.252,7.02c0,0-3.072,0.381-5.892,3.21c0,0,0.972,0.688,2.641,1.404c-2.801,2.186-3.665,4.346-3.665,4.346   c16.53,8.265,24.452-3.265,24.796-3.782C244.296,300.004,234.115,295.927,234.115,295.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M248.345,311.56c0.01,0.029,0.023,0.055,0.033,0.084v-0.132   C248.379,311.512,248.353,311.548,248.345,311.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M218.85,284.909c-1.08,0.79-2.016,2.111-2.792,3.528c-0.386-0.647-0.817-1.28-1.328-1.876   c0,0-2.469,3.017-2.779,5.826c0,0-2.729-0.802-6.141,0.552c0,0,0.568,0.935,1.713,2.149c-3.16,0.818-4.679,2.324-4.679,2.324   c10.912,13.012,21.807,6.189,22.286,5.879C225.943,292.069,218.85,284.909,218.85,284.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M225.13,303.291c-0.002,0.028-0.001,0.054-0.003,0.083l0.048-0.112   C225.176,303.262,225.141,303.284,225.13,303.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M209.379,270.507c-1.18,0.248-2.438,0.987-3.601,1.863c-0.077-0.675-0.197-1.354-0.396-2.033   c0,0-3.146,1.563-4.442,3.755c0,0-1.944-1.67-5.249-1.822c0,0,0.12,0.979,0.611,2.4c-2.899-0.499-4.704,0.175-4.704,0.175   c4.142,14.731,15.618,13.164,16.127,13.087C212.551,279.016,209.379,270.507,209.379,270.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M207.726,287.933c-0.012,0.022-0.021,0.044-0.033,0.067l0.081-0.074   C207.774,287.926,207.738,287.931,207.726,287.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M205.63,254.09c-1.119,0.073-2.421,0.561-3.669,1.181c0.086-0.595,0.133-1.199,0.11-1.811   c0,0-3.19,0.976-4.859,2.721c0,0-1.367-1.684-4.306-2.216c0,0-0.117,0.864-0.001,2.156c-2.495-0.783-4.274-0.417-4.274-0.417   c0.348,13.282,11.037,13.31,11.513,13.305C206.533,261.856,205.63,254.09,205.63,254.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M200.145,269.008c-0.016,0.018-0.029,0.036-0.045,0.054l0.09-0.054   C200.189,269.008,200.155,269.008,200.145,269.008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M206.872,240.496c-0.957-0.228-2.176-0.156-3.383,0.042c0.226-0.477,0.422-0.971,0.561-1.491   c0,0-2.928-0.007-4.78,1.025c0,0-0.711-1.766-3.039-2.973c0,0-0.321,0.694-0.559,1.809c-1.89-1.303-3.477-1.456-3.477-1.456   c-3.144,11.231,5.815,14.02,6.215,14.139C205.621,247.244,206.872,240.496,206.872,240.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M198.411,251.59c-0.018,0.011-0.033,0.023-0.052,0.034l0.089-0.022   C198.449,251.602,198.42,251.593,198.411,251.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M199.782,223.962c0,0-3.053,8,1.684,12.632c0,0,6.175-1.825,9.228-8.246l-2.596-0.491l-1.333-4   l-4.421,1.965L199.782,223.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M208.383,211.104c0,0-4.785,7.101-1.221,12.685c0,0,6.428-0.378,10.856-5.941l-2.418-1.067   l-0.393-4.198l-4.751,0.912L208.383,211.104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M256.322,313.332v-3.368c30.646,0,55.579-24.934,55.579-55.579c0-13.092-4.64-25.806-13.066-35.799   l2.576-2.171c8.938,10.602,13.859,24.086,13.859,37.97C315.27,286.888,288.826,313.332,256.322,313.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M277.885,295.927c0.736,1.256,1.099,2.98,1.26,4.732c0.666-0.479,1.371-0.924,2.138-1.298   c0,0,1.158,4.081,0.252,7.02c0,0,3.072,0.381,5.892,3.21c0,0-0.972,0.688-2.641,1.404c2.801,2.186,3.665,4.346,3.665,4.346   c-16.53,8.265-24.452-3.265-24.796-3.782C267.704,300.004,277.885,295.927,277.885,295.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M263.655,311.56c-0.01,0.029-0.023,0.055-0.033,0.084v-0.132   C263.621,311.512,263.647,311.548,263.655,311.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M293.15,284.909c1.08,0.79,2.016,2.111,2.792,3.528c0.386-0.647,0.817-1.28,1.328-1.876   c0,0,2.469,3.017,2.779,5.826c0,0,2.729-0.802,6.141,0.552c0,0-0.568,0.935-1.713,2.149c3.16,0.818,4.679,2.324,4.679,2.324   c-10.912,13.012-21.807,6.189-22.286,5.879C286.057,292.069,293.15,284.909,293.15,284.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M286.87,303.291c0.002,0.028,0.001,0.054,0.003,0.083l-0.048-0.112   C286.824,303.262,286.859,303.284,286.87,303.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M302.621,270.507c1.18,0.248,2.438,0.987,3.601,1.863c0.077-0.675,0.197-1.354,0.396-2.033   c0,0,3.146,1.563,4.442,3.755c0,0,1.944-1.67,5.249-1.822c0,0-0.12,0.979-0.611,2.4c2.899-0.499,4.704,0.175,4.704,0.175   c-4.142,14.731-15.618,13.164-16.127,13.087C299.449,279.016,302.621,270.507,302.621,270.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M304.274,287.933c0.012,0.022,0.021,0.044,0.033,0.067l-0.081-0.074   C304.226,287.926,304.262,287.931,304.274,287.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M306.37,254.09c1.119,0.073,2.421,0.561,3.669,1.181c-0.086-0.595-0.133-1.199-0.11-1.811   c0,0,3.19,0.976,4.859,2.721c0,0,1.367-1.684,4.306-2.216c0,0,0.117,0.864,0.001,2.156c2.495-0.783,4.274-0.417,4.274-0.417   c-0.348,13.282-11.037,13.31-11.513,13.305C305.467,261.856,306.37,254.09,306.37,254.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M311.855,269.008c0.016,0.018,0.029,0.036,0.045,0.054l-0.09-0.054   C311.811,269.008,311.845,269.008,311.855,269.008z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M305.128,240.496c0.957-0.228,2.176-0.156,3.383,0.042c-0.226-0.477-0.422-0.971-0.561-1.491   c0,0,2.928-0.007,4.78,1.025c0,0,0.711-1.766,3.039-2.973c0,0,0.321,0.694,0.559,1.809c1.89-1.303,3.477-1.456,3.477-1.456   c3.144,11.231-5.815,14.02-6.215,14.139C306.379,247.244,305.128,240.496,305.128,240.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M313.589,251.59c0.018,0.011,0.033,0.023,0.052,0.034l-0.089-0.022   C313.551,251.602,313.58,251.593,313.589,251.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M312.218,223.962c0,0,3.053,8-1.684,12.632c0,0-6.175-1.825-9.228-8.246l2.596-0.491l1.333-4   l4.421,1.965L312.218,223.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50AF69"
    },
    d: "M303.617,211.104c0,0,4.785,7.101,1.221,12.685c0,0-6.428-0.378-10.856-5.941l2.418-1.067   l0.393-4.198l4.751,0.912L303.617,211.104z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M256,277.895l-5.207,7.811c-0.889,1.334-0.714,3.111,0.42,4.244l4.787,4.787l4.787-4.787  c1.134-1.134,1.31-2.91,0.42-4.244L256,277.895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M258.219,285.706L256,277.895l-2.219,7.811c-0.379,1.334-0.304,3.11,0.179,4.244l2.04,4.787  l2.04-4.787C258.523,288.816,258.598,287.039,258.219,285.706z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M256,208v-21.053c0,0-8,11.509-6.737,28.351"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M220.123,208.072c-11.572,25.116,0.298,45.784,2.79,49.674c0.066,0.104,16.526-26.522,16.526-26.522   L220.123,208.072"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M232.306,242.742c-1.825-5.686-2.09-12.324,0.102-19.943l-7.161-8.584  c-5.885,15.855-3.449,27.563,2.44,35.962C229.134,247.854,230.74,245.268,232.306,242.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M239.16,232.628c-0.502,0-0.998-0.224-1.331-0.651l-21.12-27.155  c-0.572-0.734-0.439-1.793,0.294-2.362c0.738-0.572,1.793-0.438,2.363,0.296l21.12,27.155c0.572,0.734,0.439,1.793-0.294,2.362  C239.885,232.513,239.52,232.628,239.16,232.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M205.474,234.172c-6.737,67.368,47.158,50.526,50.526,43.789l-33.684-16.842l6.737-13.474  L205.474,234.172"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M221.761,241.923l-9.388-5.633c-2.112,40.032,19.266,46.699,35.033,44.713  C234.622,279.287,221.851,269.848,221.761,241.923z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M229.049,249.326c-0.304,0-0.613-0.082-0.891-0.257l-26.946-16.839  c-0.788-0.493-1.028-1.533-0.535-2.319c0.492-0.793,1.53-1.033,2.321-0.536l26.946,16.839c0.788,0.493,1.028,1.533,0.535,2.319  C230.16,249.046,229.61,249.326,229.049,249.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M291.877,208.006c11.572,25.116-0.298,45.784-2.79,49.674c-0.067,0.104-16.526-26.522-16.526-26.522  L291.877,208.006"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M279.694,242.675c1.825-5.686,2.09-12.324-0.102-19.943l7.161-8.584  c5.885,15.855,3.449,27.563-2.44,35.962C282.866,247.787,281.26,245.201,279.694,242.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M272.84,232.563c-0.36,0-0.725-0.115-1.033-0.355c-0.734-0.569-0.867-1.628-0.294-2.362l21.12-27.155  c0.572-0.734,1.628-0.865,2.363-0.296c0.734,0.569,0.867,1.628,0.294,2.362l-21.12,27.155  C273.839,232.339,273.342,232.563,272.84,232.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M306.526,234.105c6.737,67.368-47.158,50.526-50.526,43.789l33.684-16.842l-6.737-13.474  L306.526,234.105"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M290.239,241.856l9.388-5.633c2.112,40.032-19.266,46.699-35.033,44.713  C277.378,279.221,290.149,269.782,290.239,241.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M282.951,249.26c-0.561,0-1.11-0.28-1.429-0.793c-0.493-0.786-0.253-1.826,0.535-2.319l26.946-16.839  c0.791-0.497,1.829-0.257,2.321,0.536c0.493,0.786,0.253,1.826-0.535,2.319l-26.946,16.839  C283.564,249.178,283.255,249.26,282.951,249.26z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE6E6"
    },
    cx: 256,
    cy: 237.47,
    r: 13.474
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 256,
    cy: 237.47,
    r: 6.737
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M256,259.368c-0.931,0-1.684-0.753-1.684-1.684v-20.211c0-0.931,0.753-1.684,1.684-1.684  s1.684,0.753,1.684,1.684v20.211C257.684,258.615,256.931,259.368,256,259.368z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5AA0E6"
    },
    points: "302.035,277.614 211.789,277.614 222.316,257.584 289.965,257.584 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB750"
    },
    d: "M258.741,261.333h23.47l-7.301-7.301c-0.344-0.344-0.762-0.602-1.223-0.756l-2.541-0.847  c-0.916-0.305-1.922-0.171-2.725,0.365l-8.115,5.41L258.741,261.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC455"
    },
    d: "M250.76,262.596h28.012l-8.714-8.714c-0.41-0.41-0.91-0.719-1.46-0.902l-3.033-1.011  c-1.093-0.364-2.294-0.204-3.253,0.436l-9.685,6.457L250.76,262.596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD55"
    },
    d: "M241.015,264h33.827l-10.523-10.523c-0.495-0.495-1.099-0.868-1.763-1.09l-3.663-1.221  c-1.32-0.44-2.77-0.246-3.928,0.526l-11.695,7.797L241.015,264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD25A"
    },
    d: "M231.373,265.263h38.732l-12.049-12.049c-0.567-0.567-1.258-0.994-2.019-1.248l-4.194-1.398  c-1.512-0.504-3.172-0.282-4.498,0.602l-13.391,8.928L231.373,265.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M215.579,267.789h50.526l-15.718-15.718c-0.74-0.74-1.641-1.297-2.633-1.627l-5.471-1.824  c-1.972-0.657-4.138-0.367-5.867,0.786l-17.469,11.646L215.579,267.789z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M259.636,240.495h-7.283l1.677-7.032h2.531c0.82,0,1.532,0.563,1.723,1.36L259.636,240.495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M259.217,241.625h-6.538c-0.535,0-0.969-0.434-0.969-0.969v-0.323c0-0.535,0.434-0.969,0.969-0.969   h6.538c0.535,0,0.969,0.434,0.969,0.969v0.323C260.185,241.191,259.752,241.625,259.217,241.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M254.895,236.666l-1.636-0.414c-0.493-0.125-0.707-0.705-0.413-1.12l1.183-1.668L254.895,236.666z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M247.598,220.171c-0.08,0.619-0.159,1.237-0.239,1.856c2.617-1.588,5.506-2.542,8.641-2.541  c3.135,0.003,6.023,0.95,8.641,2.541c-0.08-0.619-0.159-1.238-0.239-1.856c-2.604-1.359-5.406-2.14-8.402-2.138  C253.005,218.032,250.202,218.811,247.598,220.171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AA0E6"
    },
    d: "M247.702,219.364c-0.08,0.619-0.16,1.237-0.239,1.856c2.589-1.592,5.442-2.546,8.537-2.549  c3.095,0.003,5.949,0.957,8.537,2.549c-0.08-0.619-0.159-1.238-0.239-1.856c-2.575-1.369-5.341-2.144-8.298-2.146  C253.043,217.22,250.277,217.998,247.702,219.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC800"
    },
    d: "M247.798,218.619c-0.08,0.619-0.16,1.237-0.239,1.856c2.563-1.597,5.383-2.559,8.441-2.557  c3.059,0,5.878,0.96,8.441,2.557c-0.08-0.619-0.16-1.237-0.239-1.856c-2.547-1.368-5.28-2.153-8.202-2.154  C253.079,216.464,250.346,217.25,247.798,218.619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE14E"
    },
    d: "M247.908,217.766c-0.08,0.619-0.16,1.238-0.239,1.856c2.533-1.602,5.315-2.566,8.331-2.565  c3.016,0.003,5.798,0.962,8.331,2.565c-0.08-0.619-0.16-1.237-0.239-1.856c-2.517-1.374-5.211-2.161-8.092-2.162  C253.12,215.605,250.425,216.392,247.908,217.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB14E"
    },
    d: "M248.016,216.929c-0.08,0.619-0.16,1.237-0.239,1.856c2.504-1.607,5.247-2.573,8.223-2.574  c2.975,0.004,5.719,0.964,8.223,2.574c-0.08-0.619-0.16-1.237-0.239-1.856c-2.486-1.377-5.143-2.169-7.984-2.171  C253.16,214.761,250.502,215.549,248.016,216.929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M248.062,216.572c-0.056,0.433-0.112,0.867-0.167,1.3c2.471-1.609,5.175-2.584,8.105-2.583  c2.93-0.002,5.634,0.972,8.105,2.583c-0.056-0.433-0.112-0.867-0.167-1.3c-2.473-1.379-5.115-2.173-7.938-2.174  C253.177,214.394,250.535,215.189,248.062,216.572z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M303.158,279.579h-94.316c-0.622,0-1.192-0.342-1.485-0.888c-0.293-0.549-0.26-1.214,0.084-1.73   l47.158-70.737c0.625-0.934,2.178-0.934,2.803,0l47.158,70.737c0.344,0.516,0.377,1.181,0.084,1.73   C304.35,279.237,303.78,279.579,303.158,279.579z M211.988,276.211h88.023L256,210.194L211.988,276.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M256,192c-0.931,0-1.684-0.753-1.684-1.684v-6.737c0-0.931,0.753-1.684,1.684-1.684   s1.684,0.753,1.684,1.684v6.737C257.684,191.247,256.931,192,256,192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M259.368,192h-6.737c-0.931,0-1.684-0.753-1.684-1.684s0.753-1.684,1.684-1.684h6.737   c0.931,0,1.684,0.753,1.684,1.684C261.053,191.247,260.299,192,259.368,192z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M256,313.263c-0.122,0-0.245-0.013-0.365-0.039c-1.648-0.368-7.15-1.688-8.771-3.296   c-2.059-2.046-2.072-5.385-0.028-7.447c0.992-0.997,2.311-1.549,3.717-1.553h0.018c1.4,0,2.715,0.543,3.709,1.53   c1.622,1.612,2.984,7.099,3.362,8.743c0.13,0.563-0.039,1.155-0.446,1.566C256.875,313.089,256.444,313.263,256,313.263z    M250.571,304.296c-0.447,0.148-0.987,0.201-1.345,0.559c-0.735,0.74-0.73,1.944,0.012,2.681c0.408,0.398,2.229,1.086,4.411,1.707   c-0.638-2.174-1.339-3.99-1.742-4.398l1.186-1.194l-1.188,1.194C251.548,304.49,251.074,304.296,250.571,304.296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M256,313.263c-0.444,0-0.875-0.174-1.196-0.497c-0.406-0.411-0.576-1.003-0.446-1.566   c0.378-1.645,1.74-7.132,3.362-8.743l0,0c0.998-0.99,2.188-1.441,3.727-1.53c1.406,0.003,2.725,0.556,3.715,1.553   c2.046,2.063,2.033,5.401-0.025,7.444c-1.623,1.612-7.125,2.931-8.773,3.299C256.245,313.25,256.122,313.263,256,313.263z    M258.908,303.651l1.186,1.194c-0.403,0.408-1.104,2.224-1.742,4.398c2.183-0.622,4.003-1.309,4.413-1.711   c0.74-0.734,0.745-1.938,0.008-2.678c-0.355-0.359-0.831-0.559-1.337-0.559h-0.007c-0.503,0-0.977,0.194-1.334,0.549   L258.908,303.651z M258.908,303.651h0.033H258.908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M249.263,323.368c-0.931,0-1.684-0.753-1.684-1.684c0-7.691,7.355-11.454,7.668-11.612   c0.837-0.418,1.839-0.076,2.255,0.75c0.418,0.829,0.084,1.839-0.743,2.26c-0.059,0.03-5.811,3.016-5.811,8.602   C250.947,322.615,250.194,323.368,249.263,323.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M262.737,323.368c-0.931,0-1.684-0.753-1.684-1.684c0-5.586-5.752-8.572-5.811-8.602   c-0.827-0.421-1.161-1.431-0.743-2.26c0.419-0.826,1.421-1.168,2.255-0.75c0.313,0.158,7.668,3.921,7.668,11.612   C264.421,322.615,263.668,323.368,262.737,323.368z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSv);
export default __webpack_public_path__ + "static/media/sv.71b6a2dc0b04492aebacd7a0fbfb926b.svg";
export { ForwardRef as ReactComponent };